import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const body = document.querySelector('#ScrollTop');
    body?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
    })
}, [pathname]);

  return null;
}